import React, {useEffect, useMemo, useState} from "react";
import {GetNextOfKin} from "../../redux/selfService/selfServiceSlice";
import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import {Table} from "../../components/Base/BaseTable";
import PageName from "../../components/PageName";
import {format, parseISO} from "date-fns";
import LoadingSpinner from "../../components/LoadingSpinner";
import NoTransactionImage from "../../assets/images/no-transactions.png";
import ViewNextOfKin from "./view-beneficiary";
import Card from "../../components/Base/Card";
import {FiPlus} from "react-icons/fi";

const BeneficiariesPage = ()=>{
    const dispatch = useAppDispatch()
    const { nextOfKin, isLoading, isSuccessful } = useAppSelector((state) => state?.selfService);
    const [showNoK, setShowNoK] = useState(false)
    const [currentNoK, setCurrentNoK] = useState({})
    const [isNewNok, setIsNewNok] = useState(false)

    useEffect(()=>{
        dispatch(GetNextOfKin())
    }, [])


    const columns: any = useMemo(
        () => [
            {
                Header: "#",
                accessor: "",
                // @ts-ignore
                Cell: ({ cell: { row } }) => <>{parseInt(row.id, 10)+1}</>,
            },
            {
                Header: "Name",
                accessor: "txtnoksurname",
                // @ts-ignore
                Cell: ({ cell: { row } }) => <>{row.original.txtnoksurname + " " + row.original.txtnokfirstname + " " + row.original.txtNokOthernames}</>,

            },
            {
                Header: "Date of Birth",
                accessor: "dteDob",
                // @ts-ignore
                Cell: ({ cell: { value } }) => <>{format(parseISO(value), "dd MMM yyyy")}</>,
            },
            {
                Header: "Relationship",
                accessor: "relationship",
            },
            {
                Header: "Phone Number",
                accessor: "noktxtmobile",
            },
            {
                Header: "Beneficiary Percentage",
                accessor: "beneficiaryPercentage",
            },
            {
                Header: "Action",
                accessor: "",
                // @ts-ignore
                Cell: ({ row: { original } }) => {
                    return (
                        <button
                            className="btn table-action-btn"
                            onClick={() => {
                                setCurrentNoK(original)
                                setIsNewNok(false)
                                setShowNoK(true)
                            }}
                        >
                            View
                        </button>
                    );
                },
            },
        ],
        []
    );

    const tableData: any = useMemo(
        () => nextOfKin,
        [nextOfKin]
    );

    const createNoK = ()=>{
        setIsNewNok(true);
        setShowNoK(true);
    }

    return (
        <div>
            <div className="statement-page">
                <PageName pageName={"Beneficiary"}/>
                {/* {!showNoK && <div className="flex justify-end mt-10">
                  <button className="btn btn-primary btn-b" onClick={createNoK}>
                    <FiPlus className="text-xl mr-4"/>
                    Add Beneficiary
                  </button>
                </div>
                } */}
                <div className="statement">
                    {showNoK ?

                        <ViewNextOfKin
                            isEditMode={isNewNok}
                            onClose={() => setShowNoK(false)}
                            nok={currentNoK}
                        />
                        :
                        <>
                            <div className="h1 text-grayscaleBody">Beneficiaries</div>
                            <Card className="statement-page-card">

                                {!isLoading && isSuccessful ? (
                                        tableData?.length ?
                                            <div className="mt-10">
                                                <Table
                                                 showPagination={false}
                                                    columns={columns}
                                                    data={ tableData.filter((item) => item.isBeneficiary)}
                                                    filterValue={""}
                                                />
                                            </div>
                                            :
                                            <div className="no-transaction">
                                                <img
                                                    src={NoTransactionImage}
                                                    alt=""
                                                    className="no-transaction__img"
                                                />
                                                <div className="no-transaction__text">
                                                    No transaction history
                                                </div>
                                                <div className="no-transaction__info">
                                                    Select a date range to continue
                                                </div>
                                            </div>

                                    ) :
                                    <div className="table-loading">
                                        <LoadingSpinner size={"lg"}/>
                                    </div>
                                }
                            </Card>
                        </>

                    }
                </div>
            </div>
        </div>
    )
}

export default BeneficiariesPage;